import type { ThemeOptions } from "@mui/material";

export const light = (): ThemeOptions =>
  ({
    palette: {
      background: {
        default: "#f8f8f8",
      },
      energyRed: {
        contrastText: "#fff",
        dark: "#cc0e36",
        light: "#ff4468",
        main: "#ff1243", // Equinor Energy Red
      },
      gray: {
        contrastText: "#fff",
        dark: "oklch(0.37 0.03 260)", // Tailwind gray-700
        light: "oklch(0.87 0.01 258)", // Tailwind gray-300
        main: "oklch(0.55 0.02 264)", // Tailwind gray-500
      },
      mode: "light",
      slate: {
        contrastText: "#fff",
        dark: "oklch(0.37 0.04 257)", // Tailwind slate-700
        light: "oklch(0.87 0.02 253)", // Tailwind slate-300
        main: "oklch(0.55 0.04 257)", // Tailwind slate-500
      },
      tokens: {
        decorativeSurface: "oklch(0.55 0.04 257)", // Tailwind slate-500
        decorativeSurfaceContrast: "oklch(0.97 0.01 248)", // Tailwind slate-100
        greenSurface: "oklch(0.94 0.12 124)", // Tailwind lime-200
        greenSurfaceContrast: "oklch(0.90 0.18 127)", // Tailwind lime-300
        label: "oklch(0.55 0.04 257)", // Tailwind slate-500
        mutedSurface: "oklch(0.93 0.01 256)", // Tailwind slate-200
        mutedSurfaceContrast: "oklch(0.45 0.04 257)", // Tailwind slate-600
        yellowSurface: "oklch(0.97 0.07 103)", // Tailwind yellow-100
        yellowSurfaceContrast: "oklch(0.95 0.12 102)", // Tailwind yellow-200
      },
      white: {
        contrastText: "#000",
        dark: "#f5f5f5",
        light: "#ffffff",
        main: "#fff",
      },
    },
  }) as ThemeOptions;
